import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Block } from "../block.js";
import { Rule } from "../rule.js";
/**
 * @public
 */
export class StyleRule extends Rule {
    static of(selector, declarations, hint = false) {
        return new StyleRule(selector, Array.from(declarations), hint);
    }
    _selector;
    _style;
    _hint;
    constructor(selector, declarations, hint) {
        super("style");
        this._selector = selector;
        this._style = Block.of(declarations.filter((declaration) => declaration._attachParent(this)));
        this._hint = hint;
    }
    get selector() {
        return this._selector;
    }
    get style() {
        return this._style;
    }
    get hint() {
        return this._hint;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            selector: this._selector,
            style: this._style.toJSON(),
        };
    }
    toString() {
        const style = this._style.toString();
        return `${this._selector} {${style === "" ? "" : `\n${String.indent(style)}\n`}}`;
    }
}
/**
 * @public
 */
(function (StyleRule) {
    function isStyleRule(value) {
        return value instanceof StyleRule;
    }
    StyleRule.isStyleRule = isStyleRule;
    function isEmpty(rule) {
        return rule.style.isEmpty();
    }
    StyleRule.isEmpty = isEmpty;
    /**
     * @internal
     */
    function fromStyleRule(json) {
        return Trampoline.done(StyleRule.of(json.selector, Block.from(json.style)));
    }
    StyleRule.fromStyleRule = fromStyleRule;
})(StyleRule || (StyleRule = {}));
//# sourceMappingURL=style.js.map